"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
function initializeBookingTooltip() {
    var container = document.querySelector('[data-react-newobject-booking-tooltip]');
    if (container) {
        require.ensure(['../../shared/booking_tooltip'], function () {
            var BookingTooltipComponent = require('../../shared/booking_tooltip').BookingTooltip;
            react_dom_1.render(React.createElement(BookingTooltipComponent, null), container);
        });
    }
}
exports.initializeBookingTooltip = initializeBookingTooltip;



//////////////////
// WEBPACK FOOTER
// ./src/browser/initializers/booking_tooltip.tsx
// module id = 247
// module chunks = 2